import { Scale } from '@arpeggi/shared'
import { ComponentProps, FC, useLayoutEffect, useRef } from 'react'
import { styled } from '../../../../lib/stitches'
import KeyScaleManager from './KeyScaleManager'
import { STRIPES_NC_URL, STRIPES_URL } from './PianoRollUtils'

const BackgroundContainer = styled('div', {
  backgroundImage: `url(${STRIPES_URL})`,
  backgroundRepeat: 'repeat',
  backgroundSize: '24px 192px',
  height: '100%',
  width: '100%'
})

const Background: FC<ComponentProps<typeof BackgroundContainer>> = (props) => {
  const ref = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    KeyScaleManager.subscribe('background', ({ scale }) => {
      const c = ref.current
      if (scale !== Scale.CHROMATIC)
        c.style.setProperty('background-image', `url(${STRIPES_NC_URL})`)
      else c.style.removeProperty('background-image')
    })
    return () => KeyScaleManager.unsubscribe('background')
  }, [])
  return <BackgroundContainer ref={ref} {...props} />
}

export default Background
